module.exports = __webpack_public_path__ + "img/arrow.092b6afe.svg";